import HiringPreferencesSettings from './HiringPreferencesSettings.component';

export default HiringPreferencesSettings;